// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"521cb533","158":"37763489","193":"ab14c625","462":"ff4289c6","481":"973a392d","538":"e8a2b32f","554":"5bb26061","630":"9855a06d","667":"da019e1e","824":"e54f3b00","839":"a38f1dd8","841":"68fec9a2","935":"7634d223","957":"12a2df09","966":"c103c1e3","977":"148fd37e"}[chunkId] + ".chunk.js";
};